import React, { useState, useRef } from 'react';
import { gsap } from 'gsap';

import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import './FAQ.css'

import Plus from '../assets/Plus.svg'
import Minus from '../assets/Minus.svg'

import { motion as m } from "framer-motion";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

gsap.registerPlugin(useGSAP);



const FAQ = () => {
  
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const panelsRef = useRef([]);


  //data
  const AccordionData = [
    {
      title: t("FAQ1q"),
      content: t("FAQ1a")
    },
    {
      title: t("FAQ2q"),
      content: t("FAQ2a")},
    {
      title: t("FAQ3q"),
      content: t("FAQ3a")},
    {
      title: t("FAQ4q"),
      content: t("FAQ4a")},
    {
      title: t("FAQ5q"),
      content: t("FAQ5a")},
    {
      title: t("FAQ6q"),
      content: t("FAQ6a")}
  ];

  const toggleItem = (index) => {
    const isClosing = activeIndex === index;
    setActiveIndex(isClosing ? null : index);

    panelsRef.current.forEach((panel, i) => {
      if (i === index) {
        if (isClosing) {
          // Closing the panel, animate the marginTop back to 0
          gsap.to(panel, {
            height: 0,
            opacity: 0,
            marginTop: '0px', // This will animate the margin back to 0
            duration: 0.5,
            onComplete: () => {
              panel.style.overflow = 'hidden'; // Set overflow to hidden after animation
            },
          });
        } else {
          // Opening the panel
          gsap.to(panel, {
            height: 'auto', // GSAP will use the scrollHeight internally to animate height correctly
            opacity: 1,
            marginTop: '12px', // This will animate the margin to 12px
            duration: 0.5,
          });
        }
      } else {
        // Close any other open panels
        gsap.to(panel, {
          height: 0,
          opacity: 0,
          marginTop: '0px', // Ensure other panels' margins are reset
          duration: 0.5,
          onComplete: () => {
            panel.style.overflow = 'hidden'; // Set overflow to hidden after animation
          },
        });
      }
    });
  };


  ///landing
  const elRef1 = useRef(null);
  const elRef2 = useRef(null);
  const elRef3 = useRef(null);
  const elRef4 = useRef(null);
  const elRef5 = useRef(null);
  const elRef6 = useRef(null);
  const textRef = useRef(null);

  useGSAP(() => {
    // Register the plugin
    gsap.registerPlugin(ScrollTrigger);

    //landing animation for the 'top' section        


    gsap.from([textRef.current], {
      opacity: 0,
      x: "-=50",
      delay: 0.5,
      stagger: 0.25,
      ease: "sine.out",
    });

  }, []);

  return (
    <m.div className="FAQ"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: .25 }}
    >
      {/* <TopBar/> */}
      <div className="FAQ-main">
        <div className="FAQ-main-left">
          <div className="FAQ-main-left-top">FAQ</div>
          <div className="FAQ-main-left-bottom" ref={textRef}>{t('FAQ1')} <br />
            <span style={{ color: '#005C5D' }}>  {t('FAQ2')} </span></div>
        </div>
        <div className="FAQ-main-right">
          {AccordionData.map((item, index) => (
            <div key={index} className="FAQ-item" >
              <div onClick={() => toggleItem(index)} className="FAQ-item-top">
                <div
                  className={`FAQ-item-title ${activeIndex === index ? 'active' : ''}`}
                >
                  {item.title}
                </div>
                <div className="FAQ-item-icon"> <img loading="lazy" decoding="async" alt="" src={activeIndex === index ? Minus : Plus} /></div> </div>
              <div
                className="FAQ-item-panel"
                ref={(el) => (panelsRef.current[index] = el)}
                style={{ height: 0, overflow: 'hidden', opacity: 0 }}
              >
                <p className="FAQ-item-content">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </m.div>
  )
}

export default FAQ